import React from 'react';

const RichTextBody = ({ translationKey }: { translationKey: string }) => (
  <div>
    <p dangerouslySetInnerHTML={{ __html: translationKey }} />
  </div>
);

export default RichTextBody;
